<div mat-dialog-title>
  <div class="d-flex align-items-center justify-content-center">
    <div>To Microphone</div>
    <fa-icon style="margin-left:5px" [icon]="faCircleInfo"></fa-icon>
  </div>
</div>
<div mat-dialog-content>
  <div class="container-fluid">
    <div class="row mb-1">
    <dx-select-box class="item-select-box"
                   [label]="'To Microphone'"
                   [items]="toMenuItems"
                   [value]="block.menuItems[1]"
                   [searchMode]="searchModeOption"
                   [searchExpr]="searchExprOption"
                   [searchTimeout]="searchTimeoutOption"
                   [minSearchLength]="minSearchLengthOption"
                   [searchEnabled]="true"
                   displayExpr="caption"
                   (onInitialized)="onToDropdownInitialized($event)"
                   (onValueChanged)="onToValueChanged($event)">
    </dx-select-box>
    </div>
    <div class="row">
      <div class="tile-info-description-container">
        <div class="tile-creator-image-container">
          <img class="tile-creator-image" [src]="block.menuItems[1].blobUrl" />
        </div>
        <div style="padding: 5px" [innerHTML]="block.menuItems[1].description">
        </div>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions class="project-create-footer">
  <div class="w-100 d-flex justify-content-end">
    <button mat-raised-button (click)="cancel()">
      Close
    </button>
  </div>
</div>
